import type { Article } from './articles';

const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'https://usfanslink.gay').replace(/\/+$/, '');

const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

export function websiteSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFans Spreadsheet Hub',
    url: `${SITE_URL}/`,
    inLanguage: ['en', 'es', 'fr', 'pl'],
  };
}

export function organizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'USFans Spreadsheet Hub',
    url: `${SITE_URL}/`,
    logo: FAVICON_URL,
  };
}

export function homeFaqSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is a USFans Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'A USFans Spreadsheet is an organized reference that groups USFans-related creator and product information into one easy-to-browse structure.',
        },
      },
      {
        '@type': 'Question',
        name: 'How do I find USFans creators?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'You can browse organized categories and guides, then follow the provided links to the main website for the full product range.',
        },
      },
    ],
  };
}

export function articleSchema(article: Article): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    mainEntityOfPage: `${SITE_URL}/article/${article.slug}`,
    url: `${SITE_URL}/article/${article.slug}`,
    inLanguage: 'en',
    author: {
      '@type': 'Organization',
      name: 'USFans Spreadsheet Hub',
      url: `${SITE_URL}/`,
    },
    publisher: {
      '@type': 'Organization',
      name: 'USFans Spreadsheet Hub',
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
  };
}

export function articleFaqSchema(article: Article): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: article.faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
}